import React, { useState, useEffect, useReducer } from "react";
import { Alert, Button, Card, Table } from "react-bootstrap";
import axios from "../../../../../config/axios";
import { Link } from "react-router-dom";

//import PollQuestionOptions from "./PollQuestionOptions";
import useConfirm from "../../../../../HOC/custom/useConfirm";
import { listingReducer, listingInitialState } from "../../reducers/listingReducer";
import { toastNotification } from "../../../../../config/toastNotification";
import StatsListing from "../../../../UI/shared/infoListing/StatsListing";
import PollSubmissionQuestionOptions from "./PollSubmissionQuestionOptions";

const PollSubmissionQuestionItem = ({ question }) => {

  return (
    <>
      <div class="questionItem mt-2">
        <Card className="item mb-2">
          <Card.Header className="ps-1 pe-2 py-0">
            <Card.Title className="d-flex m-0 p-0">
              <div className="d-flex ImageSectionSpacing">
                <div className="d-flex flex-column ms-1">
                  <span className="m-0 text-bold memberName">{question.question}</span>
                </div>
              </div>
            </Card.Title>
          </Card.Header>
          <Card.Body className="py-2 px-3">

            <PollSubmissionQuestionOptions question={question} />
          </Card.Body>
        </Card>
      </div>
    </>

  );
};

export default PollSubmissionQuestionItem;
